'use client';

import Link from 'next/link';
import { Box, Typography, Button, Container } from '@mui/material';
import { SearchOffOutlined as NotFoundIcon } from '@mui/icons-material';

export default function NotFound() {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          gap: 2,
        }}
      >
        <NotFoundIcon sx={{ fontSize: 64, color: 'text.secondary' }} />
        <Typography variant="displayLarge" component="h1">
          404
        </Typography>
        <Typography variant="h5" component="h2" gutterBottom>
          Page Not Found
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          The page you are looking for does not exist or has been moved.
        </Typography>
        <Button
          component={Link}
          href="/assetcast"
          variant="contained"
          sx={{ mt: 2 }}
        >
          Return to Dashboard
        </Button>
      </Box>
    </Container>
  );
}
